import { Component, inject, OnInit } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';

import { AccountResetService } from '@tfs/user-onboarding';

import { EbbotChatComponent } from './ebbot-chat/ebbot-chat.component';
import { FeedbackWidgetComponent } from './feedback-widget/feedback-widget.component';
import { DatadogRUMService } from './services/datadog-rum.service';
import { SidenavComponent } from './sidenav/sidenav.component';

@Component({
  imports: [
    RouterModule,
    MatSidenavModule,
    SidenavComponent,
    EbbotChatComponent,
    FeedbackWidgetComponent,
  ],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private readonly datadogRUMService = inject(DatadogRUMService);
  private readonly accountReset = inject(AccountResetService);

  ngOnInit() {
    this.datadogRUMService.initDatadogRUM();
    // An account being reset is off limits on every page, in every tab opened or reloaded meanwhile
    this.accountReset.openProgressIfRunning();
  }
}
